import { ModuleHeader } from "../module-header"
import AccountActionItem from "./account-actions-item"
import {
    AccountActionsCardWrapper,
    AccountSectionContainer
}
    from "./account-actions.style"

const AccountActions = () => {
    return (
        <AccountSectionContainer>
            <ModuleHeader title="account" />
            <AccountActionsCardWrapper>
                <AccountActionItem title="Account" />
                <AccountActionItem title="Profile & Privacy" />
                <AccountActionItem title="Notifications" />
                <AccountActionItem title="Change Password" />
            </AccountActionsCardWrapper>
        </AccountSectionContainer>
    )
}

export { AccountActions }
